import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import * as S from './styles';
import SquadContent from '~/pages/Match/subpages/Previous/components/SquadContent';
import CourtDiagram from '~/pages/Match/subpages/Previous/components/CourtDiagram';
import { Spinner } from '~/components';
import EmptyPage from '~/pages/EmptyPage';

export default function Squad({
  isLocal,
  team,
  trainer,
  squad,
  substitutes,
  formation,
  className,
  isFetching,
  lineupFetchFailed,
}) {
  const { t } = useTranslation();
  const [hoveredPlayer, setHoveredPlayer] = useState('0');
  if (!team) return null;

  if (lineupFetchFailed) {
    return <EmptyPage className={className} />;
  }

  return (
    <S.LocalColumn isLocal={isLocal} className={className}>
      {isFetching && <Spinner isOpen isRelative />}
      {!isFetching && (
        <>
          <S.TeamHeader isLocal={isLocal}>
            <img src={team.shieldImageUrl} alt="equipo-isLocal" />
            <div>
              <span className="name">{team.nickname}</span>
              <strong className="alignment">{t('alignment')}</strong>
            </div>
          </S.TeamHeader>

          <S.Content>
            <S.ShieldBackground isLocal={isLocal} image={team.shieldImageUrl} />

            <S.TeamSubheader isLocal={isLocal}>
              <S.TeamSubheaderColumn isLocal={isLocal}>
                <CourtDiagram
                  formation={formation}
                  inverted={!isLocal}
                  hovered={hoveredPlayer}
                  onHover={setHoveredPlayer}
                />

                <div className="trainer">
                  <h3>{t('alignment')}</h3>
                  <span>{t('trainer')}</span>
                  <strong>{trainer ? trainer.nickname : '-'}</strong>
                </div>
              </S.TeamSubheaderColumn>
            </S.TeamSubheader>

            <S.TeamSquad isLocal={isLocal}>
              <SquadContent
                squad={squad}
                substitutes={substitutes}
                isLocal={isLocal}
                hoveredPlayer={hoveredPlayer}
                onHover={setHoveredPlayer}
                isFetching={isFetching}
                withScroll
              />
            </S.TeamSquad>
          </S.Content>
        </>
      )}
    </S.LocalColumn>
  );
}

Squad.propTypes = {
  team: PropTypes.object,
  trainer: PropTypes.object,
  squad: PropTypes.array,
  substitutes: PropTypes.array,
  isLocal: PropTypes.bool,
  formation: PropTypes.array,
  className: PropTypes.string,
  isFetching: PropTypes.bool,
  lineupFetchFailed: PropTypes.bool,
};

Squad.defaultProps = {
  team: {},
  trainer: {},
  squad: [],
  substitutes: [],
  isLocal: false,
  formation: [],
  className: null,
  isFetching: false,
  lineupFetchFailed: false,
};
